import "./page_version_label.scss"

